module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"プライバシーポリシー"}}')
  delete Component.options._Ctor
}
